import { useTranslation } from "react-i18next";

const Explore = () => {
  const { t } = useTranslation();

  const categories = [
    {
      category: t("foodBeverage"),
      title: t("barClub"),
      desc: t("barClubDesc"),
      img: "/images/bar.jpg",
    },
    {
      category: t("foodBeverage"),
      title: t("cafeDessertDrinks"),
      desc: t("cafeDessertDrinksDesc"),
      img: "/images/cafe.jpg",
    },
    {
      category: t("foodBeverage"),
      title: t("bbqRestaurant"),
      desc: t("bbqRestaurantDesc"),
      img: "/images/bbq.jpg",
    },
    {
      category: t("healthBeauty"),
      title: t("wellnessHealth"),
      desc: t("wellnessHealthDesc"),
      img: "/images/health.jpg",
    },
    {
      category: t("healthBeauty"),
      title: t("beautySpa"),
      desc: t("beautySpaDesc"),
      img: "/images/spa.jpg",
    },
    {
      category: t("allAboutOnline"),
      title: t("onlineStore"),
      desc: t("onlineStoreDesc"),
      img: "/images/onlinestore.jpg",
    },
    {
      category: t("allAboutOnline"),
      title: t("catering"),
      desc: t("cateringDesc"),
      img: "/images/catering.jpg",
    },
    {
      category: t("accessories"),
      title: t("fashionClothing"),
      desc: t("fashionClothingDesc"),
      img: "/images/clothing.jpg",
    },
    {
      category: t("accessories"),
      title: t("bookStationary"),
      desc: t("bookStationaryDesc"),
      img: "/images/book.jpg",
    },
    {
      category: t("accessories"),
      title: t("electronicHomeAppliance"),
      desc: t("electronicHomeApplianceDesc"),
      img: "/images/electronic.jpg",
    },
  ];

  const groupedCategories = categories.reduce((acc, item) => {
    if (!acc[item.category]) {
      acc[item.category] = [];
    }
    acc[item.category].push(item);
    return acc;
  }, {});

  return (
    <div>
      <div id="container" className="mx-10 px-10 my-10">
        <div id="title" className="my-6 mb-8 text-center">
          <h1 className="text-3xl font-bold text-gray-800 newsreader-font">
            {t("exploreTitle")}
          </h1>
          <p className="mt-4 text-gray-600 max-w-2xl mx-auto">
            {t("exploreDescription")}
          </p>
        </div>

        <div className="space-y-10">
          {Object.entries(groupedCategories).map(([category, items]) => (
            <div key={category} className="category-group">
              <div className="flex justify-center w-60 bg-primary-color px-5 py-3 mx-auto mb-3 rounded-sm border-b-2 border-secondary-color">
                <h2 className="text-2xl inline-block font-bold text-[#E4D9FF] text-center">
                  {category}
                </h2>
              </div>
              <div className="flex justify-center space-x-10">
                <div className="flex">
                  {items.map((item, index) => (
                    <div
                      key={index}
                      className={`bg-white mt-3 transition-transform duration-300 max-w-sm mx-10 flex flex-col items-center ${
                        items.length === 3 && index === 1
                          ? "flex-col-reverse"
                          : ""
                      }`}
                    >
                      <img
                        src={process.env.PUBLIC_URL + item.img}
                        alt={item.title}
                        className="object-cover rounded-full w-56 h-56"
                      />
                      <div className="p-6 my-3">
                        <h3 className="text-lg font-semibold text-center text-gray-800 mb-2">
                          {item.title}
                        </h3>
                        <p className="text-gray-500 text-justify">
                          {item.desc}
                        </p>
                        <button className="mt-4 text-secondary-color text-center font-medium w-full">
                          <span>{t("learnMore")}</span>
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Explore;
